<template>
  <div class="what-hot">
    <div class="container list">
      <div class="suggest item">
        <div class="mask item-wrapper">
          <div class="header">
            <i class="material-icons icon">
              stars
            </i>
          </div>
          <div class="title">
            {{ $t('COMMON.RECOMMEND') }}
          </div>
          <div class="customized-wrapper">
            <div class="customized-text">
              {{ $t('LISTEN.RECOMMEND_FOR_YOU') }}
            </div>
            <a :class="{'disabled': pgnnpAudioMode}" class="customized" @click="!pgnnpAudioMode ? playRecommendation() : null">
              <PlayerStaticPlayBtn :width="clientWidth < 1440 ? 120 : 150" :height="clientWidth < 1440 ? 120 : 150" :disabled="pgnnpAudioMode" />
            </a>
          </div>
        </div>
      </div>
      <div class="hot item">
        <div class="mask item-wrapper">
          <div class="header">
            <i class="material-icons icon">
              whatshot
            </i>
          </div>
          <div class="title">
            {{ $t('COMMON.HOT') }}
          </div>
          <div class="spot-wrapper">
            <a v-for="scenario in hotScenariosList" :key="scenario.id" class="spot" @click="goToRecommendScenario(scenario)">
              <span class="text">
                {{ displayLocaleTitle(scenario) }}
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="search item">
        <div class="mask item-wrapper">
          <div class="header">
            <i class="material-icons icon">
              search
            </i>
          </div>
          <div class="title">
            {{ $t('COMMON.SEARCH') }}
          </div>
          <div class="search-block">
            <i class="material-icons icon">
              search
            </i>
            <input v-model="searchKeyword" type="text" aria-label="What hot search input"
                   :placeholder="$t('SEARCH.PLACEHOLDER')"
                   @keyup.enter="goToSearch(searchKeyword)"
            >
          </div>
          <div class="keyword-wrapper">
            <a v-for="(keyword, index) in hotSearchKeyword" :key="index" class="hot-keyword" @click="goToRecommendSearch(keyword)">
              {{ keyword }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import PeopleService from '@/assets/services/PeopleService'
import { displayComposerName } from '@/assets/helpers/TrackHelper.js'
import ScenarioService from '@/assets/services/ScenarioService'
import { displayLocaleTitle } from '@/assets/helpers/ScenarioHelper.js'
import PlayerStaticPlayBtn from '@/components/player/PlayerStaticPlayBtn'
import { getCookie } from '@/assets/helpers/UtilHelper'

export default {
  name: 'ListenWhatHot',
  components: {
    PlayerStaticPlayBtn
  },
  directives: {},
  props: {},
  data() {
    return {
      hotScenariosList: [],
      hotScenariosIdList: [
        '8bab9370-864f-48f8-81bf-db3decb14028', // Top 10 播放清單
        '8bab933e-698a-4787-80eb-85a0c22e7751', // Top-100-單曲
        '8bab9360-7edb-46c5-9aa7-7e4182cd7736', // 知名作曲家
        '8bab934c-8fc0-4d02-9bc0-e5e8c978447c', // 百首必聽
        '8bab9380-1521-4805-865a-0b6e51ad8730', // 巴洛克時期
        '8bab9348-bdc5-42b1-a75e-0fc304d80952', // 文藝復興
        '8bab938c-4046-46bb-a5d9-899235d795c7', // 運動
        '8bab930f-a704-458a-be4f-e491e9c28a5d', // 旅遊
        '8bab9365-c74d-435e-83c6-31d26f4af7da', // 睡眠
        '8bab9338-0906-46cf-9baa-df5a0fb5005e' // 心情
        // '8bab932c-d298-4361-8d2d-abbf44358b06', // 閱讀
        // '8bab9383-9511-4073-a6a9-52150f91cf40', // 星座
        // '8bab9363-d9d3-41e1-8d89-3344704f003c', // 派對
      ],
      hotComposerList: [],
      hotComposerIdList: [
        '8ba8899b-d59c-4f2c-97ef-0962bbe1bcdd', // Beethoven
        '8ba88a9d-37af-4465-a508-fe44b8811adc', // Mozart
        '8ba889c1-5b8e-467c-9fe0-aad595233a47' // Chopin
      ],
      hotSearchKeyword: [
        '貝多芬',
        '莫札特',
        '舒伯特',
        '蕭邦',
        '海頓第一號小提琴協奏曲C大調',
        '德布西',
        '拉赫曼尼諾夫',
        '巴赫'
      ],
      searchKeyword: ''
    }
  },
  computed: {
    ...mapState({
      pgnnpAudioMode: state => state.player.pgnnpAudioMode,
      isAnyPgnnpAudio: state => state.player.isAnyPgnnpAudio,
      currentTime: state => state.player.currentTime,
      paused: state => state.player.paused
    }),
    clientWidth() {
      return this.$store.state.clientWidth
    },
    paused() {
      return this.$store.state.player.paused
    },
    random() {
      return this.$store.state.player.random
    },
    trendKeywords() {
      if (this.hotComposerList && this.hotComposerList.length > 0) {
        return this.hotComposerList.map(item => {
          return this.displayComposerName(item) ? this.displayComposerName(item).split(', ')[0] : ''
        })
      } else {
        return ''
      }
    },
    initialClick() {
      return this.$store.state.player.initialClick
    }
  },
  watch: {},
  created() {
    this.getHotScenarioList()
    this.getHotComposerList()
  },
  mounted() {},
  updated() {},
  beforeDestroy() {},
  methods: {
    displayLocaleTitle,
    displayComposerName,
    getCookie,
    async playRecommendation() {
      // this.$store.commit('ALERT_MESSAGE', { message: `initialClick: ${this.initialClick}`, type: 'success' })
      const isFirstPlay = await this.getCookie('player_play_count') === null
      if (isFirstPlay) {
        // Reset all status, make a trigger animation process
        this.$store.commit('TOGGLE_PLAYER_PAUSED', true)
        this.$store.commit('TOGGLE_PLAYER_RANDOM', false)
        setTimeout(() => {
          this.$store.commit('SET_TO_PREPEND', true)
          this.$store.dispatch('PGNNP_AUDIO_NEXT')
          this.$store.commit('TOGGLE_PLAYER_PAUSED', false)
          this.$store.commit('TOGGLE_PLAYER_RANDOM', true)
        }, 200)
        if (!this.isAnyPgnnpAudio) {
          document.querySelector('#audioPlayer').play()
          document.querySelector('#audioPlayer').pause()
        }
      } else {
        if (!this.initialClick) {
          // Trigger click-to-play policy
          document.querySelector('#audioPlayer').play()
          document.querySelector('#audioPlayer').pause()
        }
        // Reset all status, make a trigger animation process
        this.$store.commit('TOGGLE_PLAYER_PAUSED', true)
        this.$store.commit('TOGGLE_PLAYER_RANDOM', false)
        this.$store.commit('TOGGLE_PLAYER_PANEL', true)
        setTimeout(() => {
          this.$store.dispatch('RANDOM_POOL').then(res => {
            this.$store.commit('TOGGLE_PLAYER_RANDOM', true)
            if (!this.paused || this.currentTime > 0) {
              this.$store.dispatch('INCREASE_PLAYING_COUNT')
            }
            // it's will trigger play by player panel watch
          })
        }, 200)
      }

      // GTAG Event
      this.$store.dispatch('GTAG_EVENT', {
        action: 'recommend_playlist_click',
        data: {
          event_category: 'recommend',
          event_label: 'Click recommend play button',
          value: this.paused
        }
      })
    },
    goToRecommendScenario(scenario) {
      this.$store.dispatch('GTAG_EVENT', {
        action: 'recommend_scenario_click',
        data: {
          event_category: 'recommend',
          event_label: `${this.displayLocaleTitle(scenario)} ${scenario.id}`,
          value: scenario.id
        }
      })
      this.$router.push({ name: 'scenarioById', params: { id: scenario.id } })
    },
    goToRecommendSearch(keyword) {
      this.$store.dispatch('GTAG_EVENT', {
        action: 'recommend_keyword_click',
        data: {
          event_category: 'recommend',
          event_label: `Keyword: ${keyword}`,
          value: keyword
        }
      })
      //
      // Re search every click event
      // keyword params
      const kParams = {
        lang: this.$i18n.locale.toLowerCase(),
        keyword: keyword,
        scope: 'air_v2',
        type: 'all',
        page: 1
      }
      this.$store.dispatch('KEYWORD_ON_SUBMIT', kParams)
      this.$router.push({ name: 'search', query: { q: keyword, type: 'all' } })
    },
    goToSearch(keyword) {
      this.$store.dispatch('GTAG_EVENT', {
        action: 'user-input-search',
        data: {
          event_category: 'search',
          event_label: `Keyword: ${keyword}`,
          value: keyword
        }
      })
      this.$router.push({ name: 'search', query: { q: keyword, type: 'all' } })
    },
    async getHotScenarioList() {
      const idList = window.innerWidth < 1440 ? this.hotScenariosIdList.slice(0, 4) : this.hotScenariosIdList
      const q = {
        id: idList
      }
      const res = await ScenarioService.getScenariosList(q)
      if (res && res.data) {
        this.hotScenariosList = res.data
      }
    },
    async getHotComposerList() {
      const q = {
        id: this.hotComposerIdList
      }
      let res = await PeopleService.getPeopleList(q)
      if (res && res.data) {
        this.hotComposerList = res.data
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.what-hot {
  .list {
    display: block;
    margin: 36px -18px;
    .item {
      float: left;
      position: relative;
      display: inline-block;
      vertical-align: top;
      width: calc(33.33% - 36px);
      height: 390px;
      margin: 0 18px;
      border-radius: 12px;
      background-color: $grey-ec;
      color: #ffffff;

      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      .mask {
        height: 100%;
        width: 100%;
        border-radius: 12px;
        background-color: rgba(0, 0, 0, 0.5);
        box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.27);
      }
      &.suggest {
        background-image: url('/img/cover-listen/img-suggest.jpg');
      }
      &.hot {
        background-image: url('/img/cover-listen/img-hot.jpg');
      }
      &.search {
        background-image: url('/img/cover-listen/img-search.jpg');
      }
      //
      &-wrapper {
        padding: 24px;
        overflow: hidden;
        .header {
          display: inline-block;
          vertical-align: top;
          .icon {
            font-size: 64px;
            color: $theme-yellow;
          }
        }
        .title {
          display: inline-block;
          vertical-align: top;
          margin: 16px 0 16px 0;
          font-size: 24px;
          font-weight: 500;
          line-height: 1.63;
        }
      }
      .customized {
        display: inline-block;
        width: 150px;
        height: 150px;
        margin: 24px 0;
        &-wrapper {
          display: block;
          text-align: center;
          border-radius: 50%;
        }
        &-text {
          font-size: 16px;
          line-height: 1.63;
          font-weight: 700;
          text-align: left;
        }
        &.disabled {
          cursor: not-allowed;
          user-select: none;
        }
      }
      .spot {
        float: left;
        width: 50%;
        margin-bottom: 8px;
        font-size: 20px;
        font-weight: 500;
        line-height: 1.6;
        @include ellipsis-with-nowrap();
        .text {
          display: inline-block;
          cursor: pointer;
          @include default-link-hover(#ffffff);
        }
      }
      // .trend {
      //   display: block;
      //   height: 55px;
      //   margin-bottom: 24px;
      //   padding: 0 16px;
      //   border-radius: 27.5px;
      //   background-color: #ffffff;
      //   text-decoration: none;
      //   cursor: pointer;
      //   @include ellipsis-with-nowrap();
      //   > .icon,
      //   .text {
      //     display: inline-block;
      //     vertical-align: top;
      //     line-height: 55px;
      //   }
      //   .icon {
      //     font-size: 24px;
      //     color: $grey-7d;
      //   }
      //   .text {
      //     font-size: 20px;
      //     font-weight: 500;
      //     color: $grey-50;
      //   }
      // }
      .search-block{
        position: relative;
        margin-bottom: 16px;
        i{
          position: absolute;
          font-size: 24px;
          height: 24px;
          color: $grey-7d;
          top: 0;
          bottom: 0;
          left: 16px;
          margin: auto;
        }
        input{
          width: 100%;
          padding: 12px 36px 12px 44px;
          background: #fff;
          border-radius: 27.5px;
          font-size: 20px;
          font-weight: 500;
          line-height: 1.6;
          color: $grey-9b;
          border: 0;
          outline: none;
          caret-color: $theme-yellow;
          &::placeholder{
            color: $grey-9b
          }
        }
      }
      .keyword-wrapper{
        height: 110px;
        overflow: hidden;
      }
      .hot-keyword{
        display: inline-block;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.6;
        padding: 8px 18px;
        border: 1px solid $grey-f3;
        border-radius: 30px;
        background-color: rgba(0, 0, 0, 0.4);
        margin: 8px 4px;
        cursor: pointer;
        transition: .25s;
        color: #fff;
        &:hover{
          color: $grey-50;
          border: 1px solid $grey-50;
          background-color: rgba(255, 255, 255, 0.85);
        }
      }
    }
    &:after {
      content: '';
      display: block;
      clear: both;
    }
  }
}
@media only screen and (min-width: 1440px) {
}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  .what-hot {
    .list {
      display: block;
      margin: 24px -15px;
      .item {
        width: calc(33.33% - 30px);
        height: 295px;
        margin: 0 15px;
        &-wrapper {
          // padding: 24px;
          .header {
            display: inline-block;
            vertical-align: top;
            .icon {
              font-size: 48px;
              color: $theme-yellow;
            }
          }
          .title {
            display: inline-block;
            vertical-align: top;
            margin: 0 0 0 8px;
            font-size: 24px;
            font-weight: 500;
            line-height: 48px;
          }
        }
        .customized {
          &-wrapper {
          }
          &-text {
            margin-top: 8px;
          }
          width: 120px;
          height: 120px;
          margin: 24px 0;
        }
        .spot {
          &-wrapper {
            margin-top: 24px;
          }
          float: left;
          width: 100%;
          margin-bottom: 8px;
        }
        .search-block{
          margin: 12px 0 8px;
          input{
            padding: 8px 36px 8px 44px;
          }
        }
        // .trend {
        //   &-wrapper {
        //     margin-top: 24px;
        //   }
        //   display: block;
        //   height: 48px;
        //   margin-bottom: 16px;
        //   padding: 0 16px;
        //   border-radius: 24px;
        //   cursor: pointer;
        //   > .icon,
        //   .text {
        //     line-height: 48px;
        //   }
        // }
      }
    }
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  .what-hot {
    .list {
      display: block;
      margin: 24px -15px;
      .item {
        width: 100%;
        height: 219px;
        margin: 0;
        &.suggest {
          display: block;
          width: calc(100% - 30px);
          margin: 0 15px;
        }
        &.hot {
          width: calc(50% - 30px);
          margin: 24px 15px;
        }
        &.search {
          width: calc(50% - 30px);
          margin: 24px 15px;
        }
        &-wrapper {
          .header {
            .icon {
              font-size: 36px;
              color: $theme-yellow;
            }
          }
          .title {
            margin: 0 0 0 8px;
            font-size: 20px;
            font-weight: 500;
            line-height: 36px;
          }
        }
        .customized {
          &-wrapper {
          }
          &-text {
            margin-top: 38px;
            max-width: 50%;
          }
          position: absolute;
          top: 50px;
          right: 96px;
          width: 120px;
          height: 120px;
          margin: 0;
        }
        .spot {
          &-wrapper {
            margin-top: 10px;
          }
          float: left;
          width: 100%;
          font-size: 18px;
          font-weight: normal;
          line-height: 28px;
        }
        // .trend {
        //   &-wrapper {
        //     margin-top: 10px;
        //   }
        //   display: block;
        //   height: 40px;
        //   margin-bottom: 8px;
        //   padding: 0 16px;
        //   border-radius: 20px;
        //   cursor: pointer;
        //   > .icon,
        //   .text {
        //     line-height: 40px;
        //   }
        // }
        .search-block{
          margin: 8px 0 4px;
          input{
            padding: 4px 36px 4px 44px;
          }
        }
        .keyword-wrapper{
          height: 92px;
        }
        .hot-keyword{
          margin: 4px;
          padding: 7px 16px;
        }
      }
    }
  }
}
@media only screen and (max-width: 767.98px) {
  .what-hot {
    .list {
      display: block;
      margin: 0 0 24px 0;
      .item {
        width: 100%;
        height: 295px;
        margin: 24px 0 0 0;
        &-wrapper {
          .header {
            display: inline-block;
            vertical-align: top;
            .icon {
              font-size: 48px;
              color: $theme-yellow;
            }
          }
          .title {
            display: inline-block;
            vertical-align: top;
            margin: 0 0 0 8px;
            font-size: 24px;
            font-weight: 500;
            line-height: 48px;
          }
        }
        .customized {
          &-wrapper {
          }
          &-text {
            margin-top: 8px;
          }
          width: 120px;
          height: 120px;
          margin: 24px 0;
        }
        .spot {
          &-wrapper {
            margin-top: 24px;
          }
          float: left;
          width: 100%;
          margin-bottom: 8px;
        }
        // .trend {
        //   &-wrapper {
        //     margin-top: 16px;
        //   }
        //   display: block;
        //   height: 48px;
        //   margin-bottom: 16px;
        //   padding: 0 16px;
        //   border-radius: 24px;
        //   cursor: pointer;
        //   > .icon,
        //   .text {
        //     line-height: 48px;
        //   }
        // }
        .search-block{
          margin: 8px 0 12px;
          input{
            padding: 8px 36px 8px 44px;
          }
        }
      }
    }
  }
}
</style>
